module.exports = __webpack_public_path__ + "img/right-arrow (1).ac6bf72f.svg";